import { z } from 'zod';

const VolumeDiscountSchema = z.object({
  cost: z.number(),
  min_cases: z.number(),
});

export type VolumeDiscount = z.infer<typeof VolumeDiscountSchema>;

export const ProductPricingSchema = z.object({
  previous_cost: z.number().optional(),
  current_cost: z.number().optional(),
  future_cost: z.number().optional(),

  previous_volume_discounts: z.array(VolumeDiscountSchema).optional(),
  volume_discounts: z.array(VolumeDiscountSchema).optional(),
  future_volume_discounts: z.array(VolumeDiscountSchema).optional(),
});
